import { SUCCESS, FETCH_SESSIONS, FETCH_SESSION } from '../constants/actionApi';
import { UPDATE_FAV_MODEL } from '../constants/actionLocal';
import { addOrUpdateItemsInState } from '../helpers/data';
import initialState from '../store/initialState';

export default (state = initialState.agendaSessions, { type, payload }) => {
  switch (type) {
    case FETCH_SESSIONS + SUCCESS:
    case FETCH_SESSION + SUCCESS:
      return addOrUpdateItemsInState(state, payload.data);
    case UPDATE_FAV_MODEL:
      if (payload.type === 'agenda_session') {
        return addOrUpdateItemsInState(state, payload.data);
      } else {
        return state;
      }
    default:
      return state;
  }
};
